import React from 'react';
import Input from '../../../components/ui/Input';

function UrlSourceFields({ values, onFieldChange }) {
  return (
    <div className="rounded-xl border border-surface-border bg-slate-50/60 p-4">
      <Input
        id="kb_url"
        label="Link do documento"
        type="url"
        value={values.url}
        onChange={onFieldChange('url')}
        placeholder="https://..."
        required
      />
      <p className="text-xs text-content-muted mt-2">
        Formatos suportados: PDF, DOC e DOCX acessíveis por URL pública.
      </p>
    </div>
  );
}

export default UrlSourceFields;
